import React from "react";
import { Dropdown, Image } from "react-bootstrap";
import logo from "../../assets/images/logo-color.png";
import { isAdmin } from "../../services/authService";

const Header = (props) => {
  return (
    <header id="header">
      <div className="container-fluid container-custom">
        <div className="row">
          <div className="col-md-10">
            <Image className="logo" src={logo} fluid />
          </div>
          {props.donotshow && isAdmin() && (
            <div className="col-md-2 mt-3">
              <Dropdown>
                <Dropdown.Toggle variant="light" id="dropdown-basic">
                  Quick Actions
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item type="button">Add Customer</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">Add Tariff Plan</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">Add Admin</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
